import { useAbstractsCount } from 'clients/internal/abstractManager';
import {
  usePapersCount,
  usePostersCount
} from 'clients/internal/platformGateway';
import { useAuthContext } from 'context/AuthProvider';

const useUserSubmissionsCount = (userId: string) => {
  // fetch all the user's events
  const { data: papersData, isLoading: papersLoading } = usePapersCount(userId);
  const { data: postersData, isLoading: postersLoading } =
    usePostersCount(userId);
  const { data: abstractsData, isLoading: abstractsLoading } =
    useAbstractsCount(userId);

  const papersCount = papersData.total;
  const postersCount = postersData.total;
  const abstractsCount = abstractsData.total;

  const submissionCount = papersCount + postersCount + abstractsCount;

  return {
    papersCount,
    postersCount,
    abstractsCount,
    submissionCount
  };
};

export default useUserSubmissionsCount;
